/* =====================================================================
   Happymami · PDP Pack termo + dosificador — secciones de abajo
   1. Termo: la curva baja de 99 °C a 69 °C con un «pop» en cada punto
   1b. Dosificador: dibujos de uso que cambian cada segundo + cifras que cuentan
   2. Números que laten (Hecho para las tomas fuera de casa)
   3. Tabla de opciones + fotos del pack que cambian de color cada 2 s
   4. Momentos de uso: puntos del carrusel en móvil y zoom suave
   Precios y enlaces: los pone la sección de Shopify en
   <script type="application/json" id="hmPkData">. En la demo se usan los de abajo.
   ===================================================================== */
(function () {
  var root = document.querySelector('.hm-pk');
  if (!root) return;
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var L = {};
  try { var jl = document.getElementById('hmPkI18n'); if (jl) L = JSON.parse(jl.textContent); } catch (e) {}
  function tx(k, d) { return L[k] || d; }
  function fillP(str, p) { return String(str).replace('[p]', p); }

  var D = { termo: '19,95 €', dosificador: '15,95 €', pack: '27,90 €', ahorro: '8 €', termoUrl: '#', dosificadorUrl: '#', packUrl: '#hm-bundle' };
  try { var j = document.getElementById('hmPkData'); if (j) { var x = JSON.parse(j.textContent); for (var k in x) if (x[k]) D[k] = x[k]; } } catch (e) {}

  /* Lanza una función una sola vez cuando el elemento entra en pantalla */
  function onView(el, fn, th) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, { threshold: th || .35 });
    io.observe(el);
  }

  /* ---------- 1. Termo: curva de temperatura (datos de la prueba de Happymami) ---------- */
  var PTS = [[0, 99, tx('tw0', 'Lo llenas y sales de casa')], [2, 95, tx('tw1', 'A las 2 horas')], [4, 90, tx('tw2', 'Paseo de media mañana')], [6, 84, tx('tw3', 'A las 6 horas')], [8, 75, tx('tw4', 'Por la tarde')], [10, 73, tx('tw5', 'A las 10 horas')], [12, 69, tx('tw6', 'De vuelta a casa')]];
  var tc = root.querySelector('[data-tc]');
  if (tc) {
    var NS = 'http://www.w3.org/2000/svg';
    /* Escala real de 0 a 120 °C */
    var X = function (h) { return 40 + 264 * h / 12; }, Y = function (c) { return 118 - c * 0.85; };
    var svg = tc.querySelector('.tc-chart'), line = tc.querySelector('.tc-line'), area = tc.querySelector('.tc-area'), g = tc.querySelector('.tc-pts');
    var cEl = tc.querySelector('[data-c]'), wEl = tc.querySelector('[data-w]'), t;
    var grid = document.createElementNS(NS, 'g'); grid.setAttribute('class', 'tc-grid'); grid.setAttribute('aria-hidden', 'true');
    [0, 40, 80].forEach(function (v) { var y = Y(v); grid.innerHTML += '<line x1="40" x2="304" y1="' + y + '" y2="' + y + '"/><text x="32" y="' + (y + 4) + '">' + v + '</text>'; });
    svg.insertBefore(grid, area);
    var d = PTS.map(function (p, n) { return (n ? 'L' : 'M') + X(p[0]).toFixed(1) + ' ' + Y(p[1]).toFixed(1); }).join(' ');
    line.setAttribute('d', d); area.setAttribute('d', d + ' L304 118 L40 118 Z');
    PTS.forEach(function (p, n) {
      var gg = document.createElementNS(NS, 'g'), x = X(p[0]), y = Y(p[1]);
      gg.setAttribute('tabindex', '0'); gg.setAttribute('role', 'button');
      gg.setAttribute('aria-label', p[0] ? String(tx('deg_hours', '{{ c }} grados a las {{ h }} horas')).replace('{{ c }}', p[1]).replace('{{ h }}', p[0]) : String(tx('deg_fill', '{{ c }} grados al llenarlo')).replace('{{ c }}', p[1]));
      gg.innerHTML = '<circle class="hit" cx="' + x + '" cy="' + y + '" r="16"/><circle class="dot" cx="' + x + '" cy="' + y + '" r="5"/>' +
        '<text class="v" x="' + x + '" y="' + (y - 12) + '">' + p[1] + '°</text><text x="' + x + '" y="138">' + p[0] + ' h</text>';
      function pick() { clearTimeout(t); gs.forEach(function (q) { q.classList.add('in'); }); area.style.opacity = 1; line.style.strokeDashoffset = 0; set(n); }
      gg.addEventListener('click', pick);
      gg.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      g.appendChild(gg);
    });
    var gs = $$('g', g);
    var DEFCAP = tx('tw_def', 'Mantiene la temperatura hasta 12 horas');
    function set(k, def) {
      var p = PTS[k];
      gs.forEach(function (q, n) { q.classList.toggle('on', n === k); q.querySelector('.dot').setAttribute('r', n === k ? 8 : 5); });
      if (cEl) cEl.textContent = p[1]; if (wEl) wEl.textContent = DEFCAP;
    }
    set(0, true);
    // Hasta que la sección entra en pantalla la curva está sin dibujar (la animación solo se ve entonces).
    if (!reduce) { try { var len0 = line.getTotalLength(); line.style.transition = 'none'; line.style.strokeDasharray = len0; line.style.strokeDashoffset = len0; area.style.opacity = 0; } catch (e) {} }
    var STEP = 380;
    function play() {
      if (reduce) { gs.forEach(function (q) { q.classList.add('in'); }); area.style.opacity = 1; set(0, true); return; }
      area.style.opacity = 0;
      try {
        var len = line.getTotalLength();
        line.style.transition = 'none'; line.style.strokeDasharray = len; line.style.strokeDashoffset = len; void line.getBBox();
        line.style.transition = 'stroke-dashoffset ' + (STEP * (PTS.length - 1)) + 'ms linear'; line.style.strokeDashoffset = 0;
      } catch (e) {}
      var k = 0;
      (function next() { gs[k].classList.add('in'); set(k); if (k < PTS.length - 1) { k++; t = setTimeout(next, STEP); } else { area.style.opacity = 1; t = setTimeout(function () { set(0, true); }, 900); } })();
    }
    onView(tc, play);
  }

  /* ---------- 1b. Dosificador: dibujos que cambian cada segundo + cifras ---------- */
  var CAP = [tx('cap1', 'Apila con un clic'), tx('cap2', 'Gira para separarlos'), tx('cap3', 'Llena hasta 12 cacitos'), tx('cap4', 'Vierte en el biberón')];
  var dzs = root.querySelector('[data-dzs]');
  if (dzs) {
    var ims = $$('img', dzs), dots = $$('.dz-dots i', dzs), nEl = dzs.querySelector('.dz-n'), cap = dzs.querySelector('.dz-cap');
    var N = ims.length, ki = 0, holdUntil = 0, dzVisible = true, dragging = false, W = 1;
    var SLIDE = reduce ? 'none' : 'transform .42s cubic-bezier(.22,1,.36,1), opacity .25s';
    // Posición de cada dibujo respecto al actual: 0 = el que se ve, -1 = anterior (a la izquierda), 1 = siguiente (a la derecha).
    // Con 4 dibujos el cuarto queda oculto detrás: el recorrido es infinito en los dos sentidos.
    function rel(j) { var r = ((j - ki) % N + N) % N; return r === 0 ? 0 : r === 1 ? 1 : r === N - 1 ? -1 : 9; }
    function layout(drag, animate) {
      ims.forEach(function (im, j) {
        var r = rel(j);
        if (r === 9) { im.style.transition = 'none'; im.style.opacity = 0; im.style.transform = 'translate(-50%,-50%) translateX(' + (W * 2) + 'px)'; return; }
        im.style.transition = animate ? SLIDE : 'none';
        im.style.opacity = 1;
        im.style.transform = 'translate(-50%,-50%) translateX(' + (r * W + drag) + 'px)';
      });
    }
    function paint() {
      dots.forEach(function (dd, j) { dd.classList.toggle('on', j === ki); });
      nEl.textContent = ki + 1; cap.textContent = CAP[ki];
    }
    // Un dibujo que da la vuelta (de un extremo al otro) salta sin animar para que el efecto sea continuo.
    function go(dir) {
      var next = (ki + dir + N) % N;
      // El dibujo oculto que va a pasar a ser vecino se coloca antes, sin animar, en el lado por el que entra
      // (derecha al avanzar, izquierda al retroceder): así nunca cruza la pantalla en sentido contrario.
      ims.forEach(function (im, j) {
        if (rel(j) !== 9) return;
        im.style.transition = 'none'; im.style.opacity = 1;
        im.style.transform = 'translate(-50%,-50%) translateX(' + (dir > 0 ? W : -W) * 2 + 'px)';
        void im.offsetWidth;
      });
      ki = next; paint(); layout(0, true);
    }
    function hold(ms) { holdUntil = Date.now() + ms; }
    setInterval(function () {
      if (reduce || document.hidden || !dzVisible || dragging || Date.now() < holdUntil) return;
      W = dzs.offsetWidth || W; go(1);
    }, 1000);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { dzVisible = es[0].isIntersecting; }, { threshold: 0.1 }).observe(dzs);
    W = dzs.offsetWidth || 1; layout(0, false); paint();
    window.addEventListener('resize', function () { W = dzs.offsetWidth || W; layout(0, false); });

    // Tocar la imagen pausa el autoplay 5 s; deslizar (dedo o ratón) pasa al siguiente / anterior y, al soltar, 5 s de pausa.
    var sx = 0, sy = 0, st = 0, pid = null, maybe = false, moved = false;
    dzs.style.touchAction = 'pan-y';
    dzs.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      W = dzs.offsetWidth || W; sx = e.clientX; sy = e.clientY; st = e.timeStamp; pid = e.pointerId; maybe = true; moved = false;
      hold(5000);
    }, { passive: true });
    dzs.addEventListener('pointermove', function (e) {
      if (!maybe || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!dragging) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { maybe = false; return; }
        if (Math.abs(dx) < 6) return;
        dragging = true; moved = true;
        try { dzs.setPointerCapture(pid); } catch (err) {}
      }
      hold(5000);
      layout(dx, false);
    }, { passive: true });
    function end(e) {
      if (!maybe || e.pointerId !== pid) return;
      maybe = false;
      hold(5000);
      if (!dragging) { go(1); return; } // un toque: pasa al siguiente (y el autoplay espera 5 s)
      dragging = false;
      try { dzs.releasePointerCapture(pid); } catch (err) {}
      var dx = e.clientX - sx, v = dx / Math.max(1, e.timeStamp - st);
      if (Math.abs(dx) > W * 0.2 || Math.abs(v) > 0.4) go(dx < 0 ? 1 : -1); else layout(0, true);
    }
    dzs.addEventListener('pointerup', end, { passive: true });
    dzs.addEventListener('pointercancel', function (e) { if (dragging) { dragging = false; maybe = false; layout(0, true); } hold(5000); }, { passive: true });
  }
  var dz = root.querySelector('[data-dz]');
  if (dz) onView(dz, function () {
    dz.classList.add('go');
    $$('b[data-to]', dz).forEach(function (el, k) {
      var to = +el.getAttribute('data-to'); if (reduce) { el.textContent = to; return; }
      el.textContent = 0; var t0 = null;
      setTimeout(function () { requestAnimationFrame(function f(tt) { if (!t0) t0 = tt; var q = Math.min(1, (tt - t0) / 900); el.textContent = Math.round(to * (1 - Math.pow(1 - q, 3))); if (q < 1) requestAnimationFrame(f); }); }, 200 + k * 150);
    });
  });

  /* ---------- 2. Números que laten ---------- */
  var items = [
    { x: 68, y: 59, t: tx('i1_t', ''), d: tx('i1_d', ''), a: [tx('i1_a1', ''), tx('i1_a2', ''), tx('i1_a3', '')], h: [tx('i1_h1', ''), tx('i1_h2', '')] },
    { x: 66, y: 10, t: tx('i2_t', ''), d: tx('i2_d', ''), a: [tx('i2_a1', ''), tx('i2_a2', '')], h: [tx('i2_h1', ''), tx('i2_h2', '')] },
    { x: 20, y: 53, t: tx('i3_t', ''), d: tx('i3_d', ''), a: [tx('i3_a1', ''), tx('i3_a2', ''), tx('i3_a3', '')], h: [tx('i3_h1', ''), tx('i3_h2', '')] }
  ];
  var open = 0, box = root.querySelector('#hmPkHs'), list = root.querySelector('#hmPkItems');
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function li(arr) { return arr.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join(''); }
  function renderItems() {
    if (!box || !list) return;
    $$('.hs', box).forEach(function (b) { b.remove(); });
    items.forEach(function (it, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'hs'; b.textContent = i + 1;
      b.style.left = it.x + '%'; b.style.top = it.y + '%'; b.setAttribute('aria-label', it.t); b.setAttribute('aria-pressed', open === i ? 'true' : 'false');
      b.onclick = function () { toggle(i); }; box.appendChild(b);
    });
    list.innerHTML = items.map(function (it, i) {
      var on = open === i;
      return '<div class="item' + (on ? ' open' : '') + '"><button type="button" class="item-btn" aria-expanded="' + on + '" data-i="' + i + '"><span class="num">' + (i + 1) + '</span><span class="item-t">' + esc(it.t) + '</span><span class="sign" aria-hidden="true">' + (on ? '−' : '+') + '</span></button>' +
        (on ? '<div class="item-body"><p>' + esc(it.d) + '</p><div class="cols"><div><h4>' + esc(tx('what', 'Qué hace')) + '</h4><ul>' + li(it.a) + '</ul></div><div><h4>' + esc(tx('how', 'Cómo te ayuda')) + '</h4><ul>' + li(it.h) + '</ul></div></div></div>' : '') + '</div>';
    }).join('');
    $$('.item-btn', list).forEach(function (b) { b.onclick = function () { toggle(+b.getAttribute('data-i')); }; });
  }
  function toggle(i) { open = open === i ? -1 : i; renderItems(); }
  renderItems();

  /* ---------- 3. Tabla de opciones ---------- */
  var packs = [
    { n: tx('termo_name', 'Termo'), p: D.termo, c: fillP(tx('pickTermo', 'Elegir termo · [p]'), D.termo), href: D.termoUrl },
    { n: tx('dos_name', 'Dosificador'), p: D.dosificador, c: fillP(tx('pickDos', 'Elegir dosificador · [p]'), D.dosificador), href: D.dosificadorUrl },
    { n: tx('n_pack', 'Pack'), p: D.pack, c: fillP(tx('pickPack', 'Elegir pack · [p]'), D.pack), href: D.packUrl }
  ];
  var rows = [
    [tx('r1', 'Termo 500 ml'), '✓', '—', '✓'],
    [tx('r2', 'Dosificador 4 compartimentos'), '—', '✓', '✓'],
    [tx('r3', 'Agua y leche, cada una en su sitio'), '—', '—', '✓'],
    [tx('r4', 'Eliges el color'), '✓', '✓', '✓'],
    [tx('r5', 'Ahorras'), '—', '—', D.ahorro]
  ];
  var pk = 2, tbl = root.querySelector('#hmPkTable'), cta = root.querySelector('#hmPkTableCta');
  function renderPacks() {
    if (!tbl) return;
    var h = '<thead><tr><th scope="col"><span class="sr">' + esc(tx('th_inc', 'Incluye')) + '</span></th>' + packs.map(function (p, i) { return '<th scope="col"><button type="button" aria-pressed="' + (pk === i) + '" data-p="' + i + '">' + p.n + '<span>' + p.p + '</span></button></th>'; }).join('') + '</tr></thead><tbody>';
    h += rows.map(function (r) { return '<tr><th scope="row" style="text-align:left">' + r[0] + '</th>' + [1, 2, 3].map(function (j) { return '<td' + (pk === j - 1 ? ' class="sel"' : '') + '>' + r[j] + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody>';
    tbl.innerHTML = h;
    if (cta) { cta.textContent = packs[pk].c; cta.setAttribute('href', packs[pk].href); if (!reduce && cta.__pkSeen) { cta.classList.remove('hm-pk-pop'); void cta.offsetWidth; cta.classList.add('hm-pk-pop'); } cta.__pkSeen = true; }
    $$('thead button', tbl).forEach(function (b) { b.onclick = function () { pk = +b.getAttribute('data-p'); renderPacks(); }; });
  }
  renderPacks();

  /* ---------- 3b. Fotos del pack que cambian de color cada 2 segundos ---------- */
  var br = root.querySelector('#hmPkRot');
  if (br) {
    var bri = $$('img', br), brk = 0, BRC = ['rosa', 'violeta', 'menta'], BRN = [tx('col_rosa', 'Rosa'), tx('col_violeta', 'Violeta'), tx('col_menta', 'Menta')], bc = br.querySelector('.br-chip b');
    var brHold = 0, brVisible = true;
    // Bolitas de color abajo al centro (píldora blanca): elegir un color pausa el autoplay 5 s.
    var bd = document.createElement('div'); bd.className = 'br-dots'; bd.setAttribute('role', 'group');
    var bdb = BRC.map(function (c, n) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'br-dot'; b.setAttribute('data-c', c);
      b.setAttribute('aria-label', BRN[n]); b.setAttribute('aria-pressed', n === 0 ? 'true' : 'false');
      b.addEventListener('click', function () { brShow(n); brHold = Date.now() + 5000; });
      bd.appendChild(b); return b;
    });
    br.appendChild(bd);
    function brShow(n) {
      brk = n;
      bri.forEach(function (im, k) { im.classList.toggle('on', k === n); });
      br.setAttribute('data-c', BRC[n]); if (bc) bc.textContent = BRN[n];
      bdb.forEach(function (b, k) { b.setAttribute('aria-pressed', k === n ? 'true' : 'false'); });
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { brVisible = es[0].isIntersecting; }, { threshold: 0.1 }).observe(br);
    if (!reduce) setInterval(function () {
      if (document.hidden || !brVisible || Date.now() < brHold) return;
      brShow((brk + 1) % bri.length);
    }, 2000);
  }

  /* ---------- 4. Momentos de uso: puntos del carrusel (móvil) y zoom al aparecer ---------- */
  var m3 = root.querySelector('#hmPkMo3');
  if (m3) {
    var m3c = $$('.mo3-card', m3), m3d = $$('#hmPkMo3Dots i'), m3t, m3hold = 0, m3auto = false, m3vis = true, m3cur = 0;
    function m3left(n) { return m3c[n].offsetLeft - m3.offsetLeft - 16; }
    function m3dots(n) { m3cur = n; m3d.forEach(function (dd, k) { dd.classList.toggle('on', k === n); }); }
    function m3go(n) {
      m3auto = true; clearTimeout(m3t);
      m3.scrollTo({ left: m3left(n), behavior: reduce ? 'auto' : 'smooth' });
      m3dots(n);
      setTimeout(function () { m3auto = false; }, 700);
    }
    m3.addEventListener('scroll', function () {
      if (!m3auto) m3hold = Date.now() + 5000; // el usuario desliza: el autoplay espera 5 s
      clearTimeout(m3t); m3t = setTimeout(function () {
        var best = 0, bd = 1e9; m3c.forEach(function (c, n) { var dd = Math.abs(m3left(n) - m3.scrollLeft); if (dd < bd) { bd = dd; best = n; } });
        m3dots(best); }, 80); }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { m3.addEventListener(ev, function () { m3hold = Date.now() + 5000; }, { passive: true }); });
    // Los puntos también sirven para ir a una tarjeta (y pausan 5 s)
    m3d.forEach(function (dd, k) { dd.style.cursor = 'pointer'; dd.addEventListener('click', function () { m3hold = Date.now() + 5000; m3go(k); }); });
    m3c.forEach(function (c) { onView(c, function () { c.classList.add('in'); }, .4); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { m3vis = es[0].isIntersecting; }, { threshold: 0.3 }).observe(m3);
    // Autoplay solo cuando es un carrusel (móvil): cada 3,5 s pasa a la siguiente y da la vuelta al llegar al final
    if (!reduce) setInterval(function () {
      if (document.hidden || !m3vis || Date.now() < m3hold) return;
      if (m3.scrollWidth <= m3.clientWidth + 4) return;
      m3go((m3cur + 1) % m3c.length);
    }, 3500);
  }

  /* ---------- Botones «Elegir pack»: suben al selector descontando la cabecera fija ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    var ch = document.querySelector('.hm-chrome');
    var off = ch ? ch.getBoundingClientRect().bottom : 0;
    window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - off - 12), behavior: reduce ? 'auto' : 'smooth' });
  });
})();
